import React from 'react';
import { NavLink, Route, Switch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AnalyticsSummary from '../Analytics/AnalyticsSummary';
import MyOffers from '../Offers/MyOffers';
import ReceivedOffers from '../Offers/ReceivedOffers';
import '../Profile/Profile.css';
import SavedSearches from '../Search/SavedSearches';
import WatchlistPage from '../Watchlist/WatchlistPage';
import './Dashboard.css';
import MyAds from './MyAds';
import SavedAds from './SavedAds';
import Settings from './Settings';
import Transactions from './Transactions';
import Addresses from './Addresses';

function Dashboard() {
  const { t } = useTranslation();
  return (
    <div className="profilePage">
      <AnalyticsSummary />
      <nav className="dashboardTabs">
        <NavLink
          exact
          to="/dashboard"
          className="dashboardTab"
          activeClassName="active"
        >
          {t('dashboard.myAds')}
        </NavLink>
        <NavLink
          to="/dashboard/saved"
          className="dashboardTab"
          activeClassName="active"
        >
          {t('dashboard.savedAds')}
        </NavLink>
        <NavLink
          to="/dashboard/offers"
          className="dashboardTab"
          activeClassName="active"
        >
          {t('common.messages')}
        </NavLink>
        <NavLink
          to="/dashboard/watchlist"
          className="dashboardTab"
          activeClassName="active"
        >
          {t('dashboard.watchlist')}
        </NavLink>
        <NavLink
          to="/dashboard/saved-searches"
          className="dashboardTab"
          activeClassName="active"
        >
          {t('dashboard.savedSearches')}
        </NavLink>
        <NavLink
          to="/dashboard/transactions"
          className="dashboardTab"
          activeClassName="active"
        >
          {t('dashboard.transactions')}
        </NavLink>
        <NavLink
          to="/dashboard/addresses"
          className="dashboardTab"
          activeClassName="active"
        >
          {t('settings.addresses')}
        </NavLink>
        <NavLink
          to="/dashboard/settings"
          className="dashboardTab"
          activeClassName="active"
        >
          {t('dashboard.settings')}
        </NavLink>
      </nav>
      <div className="dashboardContent">
        <Switch>
          <Route exact path="/dashboard" component={MyAds} />
          <Route path="/dashboard/saved" component={SavedAds} />
          <Route path="/dashboard/offers" component={OffersDashboard} />
          <Route path="/dashboard/watchlist" component={WatchlistPage} />
          <Route path="/dashboard/saved-searches" component={SavedSearches} />
          <Route path="/dashboard/transactions" component={Transactions} />
          <Route path="/dashboard/addresses" component={Addresses} />
          <Route path="/dashboard/settings" component={Settings} />
        </Switch>
      </div>
    </div>
  );
}

function OffersDashboard() {
  const { t } = useTranslation();
  return (
    <>
      <nav className="dashboardTabs dashboardTabsSub">
        <NavLink
          exact
          to="/dashboard/offers"
          className="dashboardTab"
          activeClassName="active"
        >
          {t('dashboard.sent')}
        </NavLink>
        <NavLink
          to="/dashboard/offers/received"
          className="dashboardTab"
          activeClassName="active"
        >
          {t('dashboard.received')}
        </NavLink>
      </nav>
      <Switch>
        <Route exact path="/dashboard/offers" component={MyOffers} />
        <Route path="/dashboard/offers/received" component={ReceivedOffers} />
      </Switch>
    </>
  );
}

export default Dashboard;
